import styled from 'styled-components';

export const GoToFlow = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
